import { ScaleBand, ScaleLinear, ScaleTime } from "d3"
import { PageRectangle, TraceConfig } from "../../../../Types/Trace"
import { ModalityPage } from "../../../../Data/ModalityPage"
import { ReactCallbacks } from "../../../../Types/ReactCallbacks"
import { getColors, MobergTheme } from "../../../../../../../../Moberg"


type YScale = ScaleLinear<any, any, any> | ScaleBand<any>

export type TraceRendererOptions = {
	xScale?: ScaleTime<any, any, any>
	yScale?: YScale
}

export abstract class TraceRenderStrategy {
	abstract updateConfig(traceConfig: TraceConfig): void
    abstract getOffscreenRenderer(options?: TraceRendererOptions): any
    abstract getDirectRenderer(options?: TraceRendererOptions): any
	abstract render(): void
	abstract getRenderCacheKey(): string
	abstract renderPage(page: ModalityPage, reactCallbacks: ReactCallbacks<any>, offscreenXScale: ScaleTime<any, any, any>, offscreenCanvas: OffscreenCanvas, context: CanvasRenderingContext2D, offscreenContext: OffscreenCanvasRenderingContext2D, pageRectangle: PageRectangle, unloadedPageRectangle: PageRectangle | null): void

	protected getUnloadedColor = () => {
		return getComputedStyle(document.documentElement).getPropertyValue("--color-chart-placeholder").trim() || getColors(MobergTheme.GRAY).main
	}

	protected offscreenFillInUnloadedRegion = (offscreenContext: OffscreenCanvasRenderingContext2D | null, rect: PageRectangle | null) => {
		if (offscreenContext && rect !== null) {
			offscreenContext.fillStyle = this.getUnloadedColor()
			offscreenContext.fillRect(rect.x, rect.y, rect.width, rect.height)
		}
	}
}
